$(document).ready(function () {

    window.addAddress = function () {
        $.ajax({
            url: window.location.origin + '/add-address',
            type: "get",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (view) {
                document.getElementById('div_modal').innerHTML = view;
                $("#modal_add_address").modal('show')
            },
            error: function (errors, xhr, status,) {
                alert('Ocurrió un problema')
            }
        })
    }

    window.editAddress = function () {
        $.ajax({
            url: window.location.origin + '/show-address',
            type: "get",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (view) {
                document.getElementById('div_modal').innerHTML = view;
                $("#shipping-address").modal('show')
            },
            error: function (errors, xhr, status,) {
                alert('Ocurrió un problema')
            }
        })
    }

    $(document).on('click', '.show-edit-directions', function (e) {
        e.preventDefault();
        let data = new FormData();
        let slug = $(this).data('data');
        $("#shipping-address").modal("hide");
        data.append('value', slug)
        editAddresses(data);
    });

    function editAddresses(value) {
        $.ajax({
            method: "POST",
            url: '/edit-address',
            data: value,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (view) {
                setTimeout(function () {
                    document.getElementById('div_modal').innerHTML = view;
                    $(".modal_edit_addresses").modal("show");
                }, 300);
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    }

    $(document).on('click', '.delete-attribute-link', function (e) {
        let reference = $(this).data('reference');
        let data = new FormData();
        data.append('id', reference);
        swal.fire({
            title: '¿Estas seguro?',
            text: "La dirección seleccionada sera eliminada",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#023B59',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteItem(data, reference);
            }
        })
    });

    function deleteItem(data, position) {
        $.ajax({
            method: "POST",
            url: '/delete-addresses',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success === "success") {
                    swal.fire({
                        title: 'Eliminado',
                        text: data.msg,
                        icon: 'success',
                    }).then((result) => {
                        setTimeout(function () {

                            let url = window.location.href;
                            url = url.replace('#', '');

                            //esto es por que se reutiliza el mismo codigo en el form de Mis Datos
                            if (url === window.location.origin + '/mis-datos') {
                                window.location.reload();
                            }

                            $('#shipping-address').find(".direcciones_contenedor-" + position).remove();
                        }, 300)
                    })
                } else {
                    alertError(data.msg)
                }
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    }

    $(document).on('click', '#open_modal_add_address_from_show_directions', function (e) {
        $("#shipping-address").modal('hide');
        setTimeout(function () {
            addAddress();
        }, 300)
    });

    $(document).on('keyup', '.change_address', function (e) {
        let data = new FormData();
        data.append('zipCode', $(".change_address").val());
        getInfoByZipCode(data);
    })

    $(document).on('keyup', '.item-codigo_postal', function (e) {
        let data = new FormData();
        data.append('zipCode', $(".item-codigo_postal").val());
        getInfoByZipCodeEdit(data)
    })

    function getInfoByZipCode(datos) {
        $.ajax({
            url: "/get-info-by-zip-code",
            type: "POST",
            data: datos,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success === "success") {
                    clearSpan()
                    listZipCodes(data.zipCodes);
                } else {
                    $("#list-zipCode").hide();
                    $("#item-codigo-postal-error").html(data.msg).css('color', 'red')
                    clearInputs();
                }
            },
            error: function (errors) {
                var indices = errors.responseJSON;
                $.each(indices, function (index, value) {
                    console.log(index, value)
                });
            }
        });
    }

    function getInfoByZipCodeEdit(datos) {
        $.ajax({
            url: "/get-info-by-zip-code",
            type: "POST",
            data: datos,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success == "success") {
                    clearSpan()
                    listZipCodes1(data.zipCodes);
                } else {
                    $(".item-codigo-postal-error").html(data.msg).css('color', 'red')
                    $("#list-zipCode1").hide();
                    $("#item-codigo-postal-error").html(data.msg).css('color', 'red')

                }

            },
            error: function (errors) {
                var indices = errors.responseJSON;
                $.each(indices, function (index, value) {

                });
            }
        });
    }

    function clearSpan() {
        $("#item-nombre-error").html("");
        $("#item-telefono-error").html("");
        $("#item-codigo-postal-error").html("");
        $("#item-estado-error").html("");
        $("#item-ciudad-error").html("");
        $("#item-municipio-error").html("");
        $("#item-colonia-error").html("");
        $("#item-calle-error").html("");
        $("#item-num_exterior-error").html("");
        $("#item-num_interior-error").html("");
        $("#item-direccion_predeterminada-error").html("");
        $("#item-referencia-error").html("");

        $(".item-error-phone").html("");
    }

    function listZipCodes(data, ele) {
        $("#list-zipCode").show();
        $("#list-zipCode").html("");
        let item;
        $.each(data, function (key, value) {
            item = '<a href="#" data-id="' + data[key].id + '" data-ciudad="' + data[key].ciudad + '"  ' +
                'data-estado="' + data[key].estado + '" data-municipio="' + data[key].municipio + '" ' +
                'data-tipo_asenta="' + data[key].d_tipo_asenta + '" data-colonia="' + data[key].colonia + '" ' +
                'data-municipo="' + data[key].municipo + '" ' +
                'class="list-group-item list-group-item-action select-item" >' + data[key].d_tipo_asenta + " - " + data[key].colonia + " - " + data[key].municipio + ' </a>';
            $("#list-zipCode").append(item);
        });
    }

    function listZipCodes1(data, ele) {
        $("#list-zipCode1").show();
        $("#list-zipCode1").html("");
        let item;
        $.each(data, function (key, value) {
            item = '<a href="#" data-zip_code_id="' + data[key].id + '" data-ciudad="' + data[key].ciudad + '"  ' +
                'data-estado="' + data[key].estado + '" data-municipio="' + data[key].municipio + '" ' +
                'data-tipo_asenta="' + data[key].d_tipo_asenta + '" data-colonia="' + data[key].colonia + '" ' +
                'data-municipo="' + data[key].municipo + '" ' +
                'class="list-group-item list-group-item-action select-item1" >' + data[key].d_tipo_asenta + " - " + data[key].colonia + " - " + data[key].municipio + ' </a>';
            $("#list-zipCode1").append(item);
        });
    }

    function clearInputs() {
        $("#estado").val("");
        $("#ciudad").val("");
        $("#municipio").val("");
        $("#colonia").val("");
    }

    $(document).on('click', ".select-item", function (e) {
        e.preventDefault();
        var colonia = $(this).attr("data-tipo_asenta") + " " + $(this).attr("data-colonia");
        $("#id").val($(this).attr("data-id"));
        $("#estado").val($(this).attr("data-estado"));
        $("#ciudad").val($(this).attr("data-ciudad"));
        $("#municipio").val($(this).attr("data-municipio"));
        $("#colonia").val(colonia);
        $("#list-zipCode").hide();
    });

    $(document).on('click', '.select-item1', function (e) {
        e.preventDefault();
        var colonia = $(this).attr("data-tipo_asenta") + " " + $(this).attr("data-colonia");
        $(".item-zip_code_id").val($(this).attr("data-zip_code_id"));
        $(".item-estado").val($(this).attr("data-estado"));
        $(".item-ciudad").val($(this).attr("data-ciudad"));
        $(".item-municipio").val($(this).attr("data-municipio"));
        $(".item-colonia").val(colonia);
        $("#list-zipCode1").hide();
    });

    $(document).on('submit', "#form-agregar-direccion", function (e) {
        e.preventDefault();
        const data = $(this).serialize();

        $.ajax({
            method: "POST",
            url: window.location.origin + '/add-address',
            data: data,
            success: function (data) {
                //console.log(data);
                if (data.status == "success") {
                    $('#modal_add_address').modal('hide');
                    swal.fire({
                        title: data.title,
                        text: data.message,
                        icon: 'success',
                    }).then((result) => {
                        loading_small_small('div_address');
                        setTimeout(function () {

                            let url = window.location.href;
                            url = url.replace('#', '');

                            //esto es por que se reutiliza el mismo codigo en el form de Mis Datos
                            if (url === window.location.origin + '/mis-datos') {
                                window.location.reload();
                            }

                            document.getElementById('div_address').innerHTML = data.view;
                            document.getElementById('form_method_payment').innerHTML = data.viewPaymentMethods;
                            document.getElementById('almadia_shopping_cart_total').innerHTML = data.viewResumen;
                        }, 700);
                    });
                } else {
                    alertSuccess('Ocurrió un problema')
                    setTimeout(function () {
                        location.reload();
                    }, 700);
                }
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    });

    $(document).on('submit', "#form-edit-direccion", function (e) {
        e.preventDefault();
        const data = $(this).serialize();

        $.ajax({
            method: "POST",
            url: '/update-addresses',
            data: data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {

                if (data.status == "success") {
                    $('#modal_edit_addresses').modal('hide');
                    swal.fire({
                        title: data.title,
                        text: data.message,
                        icon: 'success',
                    }).then((result) => {
                        loading_small_small('div_address');
                        setTimeout(function () {

                            let url = window.location.href;
                            url = url.replace('#', '');

                            //esto es por que se reutiliza el mismo codigo en el form de Mis Datos
                            if (url === window.location.origin + '/mis-datos') {
                                window.location.reload();
                            }

                            document.getElementById('div_address').innerHTML = data.view;
                            document.getElementById('form_method_payment').innerHTML = data.viewPaymentMethods;
                            document.getElementById('almadia_shopping_cart_total').innerHTML = data.viewResumen;

                        }, 700);
                    });
                } else {
                    alertSuccess('Ocurrió un problema')
                    setTimeout(function () {
                        location.reload();
                    }, 700);
                }
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });

    })

    $(document).on('change', '.item-direccion_predeterminada', function () {

        if (this.checked) {
            let data = new FormData();
            data.append('id', $(".item-id").val());
            sendData(data);
        }
    })

    function sendData(data) {
        $.ajax({
            method: "POST",
            url: '/select-address',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.status === "fail") {
                    //no se hace nada *Checar comentarrios en el controlador*
                } else if (data.status === "success") {
                    $(".modal_edit_addresses").modal('hide');
                    swal.fire({
                        title: data.title,
                        text: data.message,
                        icon: 'success',
                    }).then((result) => {
                        loading_small_small('div_address');
                        setTimeout(function () {
                            document.getElementById('div_address').innerHTML = data.view;
                            document.getElementById('form_method_payment').innerHTML = data.viewPaymentMethods;
                            document.getElementById('almadia_shopping_cart_total').innerHTML = data.viewResumen;
                        }, 700);
                    });
                } else {
                    alertSuccess('Ocurrió un problema')
                    setTimeout(function () {
                        location.reload();
                    }, 700);
                }
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    }


    $("#form-my-data").on('submit', function (e) {
        e.preventDefault();
        $.ajax({
            method: "POST",
            url: window.location.origin + "/update-user",
            data: $(this).serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success === "success") {
                    /*swal.fire({
                        title: 'Actualizado',
                        text: data.msg,
                        icon: 'success',
                        iconColor: '#FF5001',
                        //confirmButtonColor: '#FF5001',
                    }).then((result) => {
                        window.location.reload();
                    });*/
                    alertSuccess(data.msg)
                } else {
                    alertError(data.msg);
                }
                setTimeout(function () {
                    window.location.reload();

                }, 1500);
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-error-" + index).text(value);
                });
            }
        })

    });


})
